// NPM Dependencies
import * as angular from 'angular';
import { GoogleStreetViewComponent } from './google-street-view.component';
import { googleStreetViewModal } from './google-street-view.modal';

export default angular.module('googleStreetView', [])
  .service('googleStreetViewModal', googleStreetViewModal)
  .component('googleStreetView', GoogleStreetViewComponent)
  .name;
